import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.adminCurrency;

export const adminCurrenciesSelector = createSelector(getState, (state) => state.currencies);
export const adminCurrenciesMetaSelector = createSelector(
  getState,
  (state) => state.currenciesMeta,
);
export const isLoadingCurrenciesSelector = createSelector(
  getState,
  (state) => state.isLoadingCurrencies,
);

export const selectedCurrencySelector = createSelector(getState, (state) => state.selectedCurrency);
export const isLoadingCurrencySelector = createSelector(
  getState,
  (state) => state.isLoadingCurrency,
);

export const adminCurrencyErrorsSelector = createSelector(getState, (state) => state.errors);

export const adminNetworksSelector = createSelector(getState, (state) => state.networks);

export const validatorOptionsSelector = createSelector(getState, (state) => state.validatorOptions);
export const labelOptionsSelector = createSelector(getState, (state) => state.labelOptions);

export const paymentsSelector = createSelector(getState, (state) => state.payments);
